<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import TemplateComponent from './TemplateComponent.vue';

    export default {
    name: 'TemplatePage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, TemplateComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <TemplateComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>